/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';

const ListSort = props => {
  if (!props.show) return <div className="no-sort"> &nbsp; </div>;
  return (
    <button type="button" className="btn btn-link">
      {props.sortDescending ? (
        <span
          className="glyphicon glyphicon-triangle-bottom"
          aria-hidden="true"
        />
      ) : (
        <span className="glyphicon glyphicon-triangle-top" aria-hidden="true" />
      )}
    </button>
  );
};

ListSort.propTypes = {
  show: PropTypes.bool,
  sortDescending: PropTypes.bool
};

export default ListSort;
